import { isDenebEnabled } from '@/const/flags'

import { Header as AltairHeader } from './Header.altair'
import { Header as DenebHeader } from './Header.deneb'

export const Header = isDenebEnabled ? DenebHeader : AltairHeader
